import { render, staticRenderFns } from "./accounttypes.vue?vue&type=template&id=92627fb4&"
import script from "./accounttypes.vue?vue&type=script&lang=js&"
export * from "./accounttypes.vue?vue&type=script&lang=js&"
import style0 from "./accounttypes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports